























































































































import Vue, { PropType } from "vue";
import { LabDataContent } from "@/features/coreWebVitals/types";
import {
  getFcpMark,
  getLcpMark,
  getSiMark,
  getClsMark,
  getTtiMark,
  getTbtMark,
} from "@/features/coreWebVitals/utils";
import LabDataItem from "@/features/coreWebVitals/components/labDataItem.vue";
import LabDataScore from "@/features/coreWebVitals/components/labDataScore.vue";

export default Vue.extend({
  components: {
    "lab-data-item": LabDataItem,
    "lab-data-score": LabDataScore,
  },
  props: {
    labData: { type: Object as PropType<LabDataContent>, required: true },
    loading: { type: Boolean, required: true },
    isNoSelectDomain: { type: Boolean, required: true },
    labDataLastUpdateDateTime: { type: String, required: true },
    isDisplayAllNoData: { type: Boolean },
  },
  methods: {
    isNoLabFcpData() {
      return this.labData.fcp === null;
    },
    isNoLabTtiData() {
      return this.labData.tti === null;
    },
    isNoLabSiData() {
      return this.labData.si === null;
    },
    isNoLabTbtData() {
      return this.labData.tbt === null;
    },
    isNoLabLcpData() {
      return this.labData.lcp === null;
    },
    isNoLabClsData() {
      return this.labData.cls === null;
    },
    getFcpColor(data: number) {
      const [colorCode, _] = getFcpMark(data);
      return colorCode;
    },
    getTtiColor(data: number) {
      const [colorCode, _] = getTtiMark(data);
      return colorCode;
    },
    getSiColor(data: number) {
      const [colorCode, _] = getSiMark(data);
      return colorCode;
    },
    getTbtColor(data: number) {
      const [colorCode, _] = getTbtMark(data);
      return colorCode;
    },
    getLcpColor(data: number) {
      const [colorCode, _] = getLcpMark(data);
      return colorCode;
    },
    getClsColor(data: number) {
      const [colorCode, _] = getClsMark(data);
      return colorCode;
    },
    getFcpSharp(data: number) {
      const [_, sharp] = getFcpMark(data);
      return sharp;
    },
    getTtiSharp(data: number) {
      const [_, sharp] = getTtiMark(data);
      return sharp;
    },
    getSiSharp(data: number) {
      const [_, sharp] = getSiMark(data);
      return sharp;
    },
    getTbtSharp(data: number) {
      const [_, sharp] = getTbtMark(data);
      return sharp;
    },
    getLcpSharp(data: number) {
      const [_, sharp] = getLcpMark(data);
      return sharp;
    },
    getClsSharp(data: number) {
      const [_, sharp] = getClsMark(data);
      return sharp;
    },
    isDisplaySupplement() {
      return (
        !this.isNoSelectDomain &&
        !this.loading &&
        this.labDataLastUpdateDateTime !== "" &&
        !this.isDisplayAllNoData
      );
    },
  },
});
